<template>
  <el-container>
    <el-header style="margin-top: 20px;">
      <span>Grabar Acta Valorización Infraestructura</span>
    </el-header>
    <el-main style="width: 100%; margin-top: 20px;">
      <el-form
        :model="form"
        ref="form-acta-valor-infra"
        label-width="120px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="Fecha de Corte" prop="acco_fechacorte">
              <el-tooltip content="Fecha de Corte" placement="top">
                <el-date-picker
                  v-model="acco_fechacorte"
                  type="month"
                  format="yyyy-MM"
                  placeholder="Seleccionar mes y año"
                ></el-date-picker>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="FAOM" prop="acvi_faom">
              <el-input v-model="form.acvi_faom" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="FAOMS" prop="acvi_faoms">
              <el-input v-model="form.acvi_faoms" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="ID" prop="acvi_idd">
              <el-tooltip
                content="Indice de Disponibilidad del mes"
                placement="top"
              >
                <el-input
                  v-model="form.acvi_idd"
                  type="number"
                  step="0.01"
                ></el-input>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="Tarifa ($/KWH)" prop="acvi_tarifa">
              <el-tooltip content="Tarifa en KWH" placement="top">
                <el-input
                  v-model="form.acvi_tarifa"
                  type="number"
                  step="0.01"
                ></el-input>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-tooltip content="Carga por Indisponibilidad" placement="top">
              <el-form-item
                label="Carga Por Indisponible (KW/h)"
                prop="acvi_cargaindisponib"
                label-width="230px"
              >
                <el-input
                  v-model="form.acvi_cargaindisponib"
                  type="number"
                  step="0.01"
                ></el-input>
              </el-form-item>
            </el-tooltip>
          </el-col>
          <el-col :span="8">
            <el-tooltip content="Numero de horas sin servicio" placement="top">
              <el-form-item
                label="Horas Sin Servicio (HSS)"
                prop="acvi_horassinserv"
                label-width="200px"
              >
                <el-input
                  v-model="form.acvi_horassinserv"
                  type="number"
                  step="0.01"
                ></el-input>
              </el-form-item>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-row>
          <add-elements @update:datos="handleElementos"></add-elements>
        </el-row>
        <el-row>
          <el-form>
            <el-col>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('form-acta-valor-infra')"
                  >Grabar</el-button
                >
                <el-button @click="resetForm('form')">Restablecer</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { saveValorInfraestructura } from '@/api/actas'
  import AddElements from './AddElements.vue'
  export default {
    components: {
      AddElements
    },
    data() {
      const currentYear = new Date().getFullYear()

      return {
        form: {
          acvi_faom: 0.013,
          acvi_faoms: 0,
          acvi_idd: null,
          acvi_tarifa: null,
          acvi_cargaindisponib: null,
          acvi_horassinserv: null,
          eluc_id: null
        },
        elementos: null,
        acco_fechacorte: new Date(),
        rules: {
          acvi_idd: [
            {
              required: true,
              message: 'Por favor ingresa un valor para ID',
              trigger: 'blur'
            }
          ],
          acvi_tarifa: [
            {
              required: true,
              message: 'Por favor ingresa un valor para Tarifa',
              trigger: 'blur'
            }
          ],
          acvi_cargaindisponib: [
            {
              required: true,
              message: 'Por favor ingresa un valor para carga por indisponible',
              trigger: 'blur'
            }
          ],
          acvi_horassinserv: [
            {
              required: true,
              message: 'Por favor ingresa un valor para horas sin servicio',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    mounted() {
      // Cargar datos del localStorage al montar el componente
      const savedData = localStorage.getItem('acta_form_data')
      if (savedData) {
        const parsedData = JSON.parse(savedData)
        this.form = parsedData.form
        this.elementos = parsedData.elementos
        this.acco_fechacorte = parsedData.acco_fechacorte
      }
    },
    methods: {
      saveToLocalStorage() {
        const dataToSave = {
          form: this.form,
          elementos: this.elementos,
          acco_fechacorte: this.acco_fechacorte
        }
        localStorage.setItem('acta_form_data', JSON.stringify(dataToSave))
      },
      handleElementos(elementos) {
        this.elementos = elementos
      },
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            // Establecer valor constante para acvi_faom
            this.form.acvi_faom = 0.103
            this.form.acvi_faoms = 0
            let data = {}
            this.elementos.forEach(element => {
              data[element.eluc_nombre] = []
              data[element.eluc_nombre] = element.elements
            })
            const fecha_periodo = `${this.acco_fechacorte.getFullYear()}-${String(
              this.acco_fechacorte.getMonth() + 1
            ).padStart(2, '0')}-01`
            const datos = {
              cto_max_aom: {
                acvi_faom: parseFloat(this.form.acvi_faom),
                acvi_faoms: parseFloat(this.form.acvi_faoms),
                acvi_idd: parseFloat(this.form.acvi_idd),
                acvi_tarifa: parseFloat(this.form.acvi_tarifa),
                acvi_cargaindisponib: parseFloat(
                  this.form.acvi_cargaindisponib
                ),
                acvi_horassinserv: parseFloat(this.form.acvi_horassinserv)
              },
              datos: data,
              acco_fechacorte: fecha_periodo,
              usua_id: this.usuario.usua_id,
              empr_id: this.empresa.empr_id
            }
            //console.log(datos)
            saveValorInfraestructura(datos)
              .then(response => {
                if (response.data.created) {
                  this.$message({
                    message: 'Acta grabada con éxito',
                    type: 'success'
                  })
                  this.resetForm('form-acta-valor-infra')
                  localStorage.removeItem('acta_form_data')
                } else {
                  this.$message({
                    message: 'Error al grabar el acta',
                    type: 'error'
                  })
                }
              })
              .catch(err => {
                console.error(err)
                this.$message({
                  message: 'Error al grabar el acta',
                  type: 'error'
                })
              })
          } else {
            console.log('error en el formulario')
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      }
    },
    computed: {
      ...mapGetters(['empresa', 'usuario'])
    },
    watch: {
      // Cada vez que cambie el formulario o los elementos, guarda en localStorage
      form: {
        handler(val) {
          this.saveToLocalStorage()
        },
        deep: true
      },
      elementos: {
        handler(val) {
          this.saveToLocalStorage()
        },
        deep: true
      },
      acco_fechacorte(val) {
        this.saveToLocalStorage()
      }
    }
  }
</script>

<style scoped></style>
